export function setCompany(data) {
  return {
    type: 'SET_COMPANY',
    payload: data,
  };
};